import React from 'react'
import { StyledTagSelector } from "./TagSelector.styles"
const AlterTag = ({
    buttonTitle,
    isDelete,
    message,
    onCancel = () => { },
    onsubmit = () => { },
}) => {
    return (
        <StyledTagSelector className="alter-tag-container">
            <div className="tag-name">{message}</div>
            <div className="tag-actions">
                <button
                    type="button"
                    className="action-btn cancel-btn"
                    title="Cancel"
                    onClick={onCancel}>
                    Cancel
                </button>
                <button
                    type="button"
                    className={`action-btn ${isDelete ? 'delete-btn' : 'edit-btn'}`}
                    title={buttonTitle}
                    onClick={onsubmit}>
                    {buttonTitle}
                </button>
            </div>
        </StyledTagSelector>
    )
}

export default AlterTag